module.exports = __webpack_public_path__ + "static/media/logo.e413bbe5.png";